import { withStore } from 'store';
import { Col, Row, Container } from 'react-bootstrap';
import Rating from 'react-rating';
import ProgressBarContainerReview from '../ProgressBarContainer';
import './style.scss';

function Reviews({ stats }) {
  const { score, ratings = [] } = stats;

  return (
      <Container>
          <Row className="mb-3">
              <Col className="mt-1 mb-n2">
                  <p className="text-center general-title" style={{ marginLeft: '10rem' }}>Calificación general</p>
              </Col>
          </Row>
          <Row className="align-items-center">
              <Col xs={12} md={6} className="d-flex justify-content-center mb-3 mb-md-0">
                  <div className="Circle">
                      <h1 style={{ marginLeft: '8rem', fontSize: '5rem !important' }} className="score">
                          <b>{score}</b>
                      </h1>
                  </div>
              </Col>
              <Col xs={12} md={6} className="mb-3 mb-md-0">
                  <div className="Review__contRating2 text-center">
                      <Rating
                          initialRating={score}
                          emptySymbol={<i className={'fa fa-star-o fa-2x'} style={{ color: '#F5A623' }}></i>}
                          fullSymbol={<i className={'fa fa-star fa-2x'} style={{ color: '#F5A623' }}></i>}
                          readonly
                      />
                  </div>
                  <div className="rating-subtitle">
                      Basada en 500 reseñas
                  </div>
              </Col>
          </Row>
          <Row>
              <Col className="Review__contRating__Progress">
                  {ratings.map(({ rating, value }) => (
                      <ProgressBarContainerReview
                          key={rating}
                          rating={rating}
                          average={value}
                      />
                  ))}
              </Col>
          </Row>
      </Container>


      /*<section className="Review">
        <div className="container">
          <article className="Review__cont">
            <div className="average">
              <div>
                <h2 className="Review__contTitle">
                  Opiniones de los clientes
                </h2>
              </div>
              <div className="Review__contRating">
                <Col
                  xs={6}
                  md={6}
                  className="Review__contRating__Circle d-flex flex-column justify-content-center align-items-center"
                >
                  <div />
                  <div className="Circle">{score}</div>

                  <div className="Review__contRating2">
                    <Rating
                      initialRating={score}
                      emptySymbol={
                        isMobile ? 'fa fa-star-o fa-lg' : 'fa fa-star-o fa-2x'
                      }
                      fullSymbol={
                        isMobile ? 'fa fa-star fa-lg' : 'fa fa-star fa-2x'
                      }
                      readonly
                    />
                  </div>
                </Col>
                <Col xs={6} className="Review__contRating__Progress mr-md-0">
                  {ratings.map(({ rating, value }) => (
                    <ProgressBarContainerReview
                      key={rating}
                      rating={rating}
                      average={value}
                    />
                  ))}
                </Col>
              </div>
            </div>
          </article>
        </div>
                  </section>*/
  );
}

export default withStore({
  mapStateToProps: (state) => ({
    stats: state.reviews.stats,
  }),
})(Reviews);
